import Task from "../../../../../lib/html5-software-library/src/ranj/util/executor/Task";
import Config from "../../../core/config/Config";
import NGTConfigKey from "../../../ngt/base/NGTConfigKey";
import DebugModel from "../../debug/model/DebugModel";
import MockPlatformUserService from "../controller/MockPlatformUserService";
import PlatformUserService from "../controller/PlatformUserService";
import PlatformUserTrackingService from "../controller/PlatformUserTrackingService";

export default class InitializePlatformTask extends Task {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher
     * @param {Config} config
     * @param {infuse.Injector} injector
     */
    constructor(dispatcher, config, injector) {
        super();

        this._dispatcher = dispatcher;
        this._config = config;
        this._injector = injector;
    }

    async execute(callback) {
        if (DebugModel.mockPlatform) {
            console.warn(`[${InitializePlatformTask.name}] Mock platform integration enabled. Using MockPlatformUserService.`);
            this._injector.mapClass("platformUserService", MockPlatformUserService);

            callback();
            return;
        }

        if (this._config.getValue(NGTConfigKey.PLATFORM_INTEGRATION_ENABLED) === false) {
            console.warn(`[${InitializePlatformTask.name}] Platform integration is disabled via config. Using MockPlatformUserService.`);
            this._injector.mapClass("platformUserService", MockPlatformUserService);

            callback();
            return;
        }

        this._injector.mapClass("platformUserService", PlatformUserService, true);
        callback();
    }
}
